import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import QRCode from 'qrcode.react';

const TwoFactorActivateBlockGuildeGauth = ({ qr }) => {
  return qr ? (
    <Fragment>
      <div className="two-factor-activate-block-disclaimer">
        <h6>Подтверждение через приложение</h6>
        <p>
          <FormattedMessage
            id="pages.profile.security.gauth.disclaimer"
            defaultMessage="Your additional account access code changes every 30 seconds."
          />
        </p>
      </div>

      <QRCode value={qr} size={200} />

      <ul className="list-unstyled two-factor-activate-block-guide-list">
        <li className="two-factor-activate-block-guide-list-item">
          <FormattedMessage
            id="pages.profile.security.gauth.guide.1"
            defaultMessage="1. Download the Google Authenticator App"
          />
        </li>
        <li className="two-factor-activate-block-guide-list-item">
          <FormattedMessage
            id="pages.profile.security.gauth.guide.2"
            defaultMessage="2. Scan QR code"
          />
        </li>
        <li className="two-factor-activate-block-guide-list-item">
          <FormattedMessage
            id="pages.profile.security.gauth.guide.3"
            defaultMessage="3. Enter the appeared 6-digit code and press the confirm button."
          />
        </li>
      </ul>
    </Fragment>
  ) : null;
};

export default TwoFactorActivateBlockGuildeGauth;
